import {
  AuthorityType,
  InjuredType,
  VehicleType,
} from "src/types/formik/formik-accident.types";

export type DatiGeneraliDTO = {
  dataIncidente: string;
  luogoIncidente: string;
  feriti?: boolean;
  listaFeriti?: FeritiDTO[];
  interventoAutorita?: boolean;
  autorita?: AuthorityType;
  danniAltriVeicoli?: boolean;
  ulterioriDatiDanniVeicoli?: string;
  danniAltriOggetti?: boolean;
  ulterioriDatiDanniOggetti?: string;
  testimoni?: TestimoniDTO[];
  circostanzeIncidenteVeicolo: CircostanzeIncidenteDTO[];
};

export type FeritiDTO = {
  tipo?: InjuredType;
  cognome?: string;
  nome?: string;
  telefono?: string;
  email?: string;
  codiceFiscale?: string;
  indirizzo?: string;
  luogoNascita?: string;
  dataNascita?: string;
  prontoSoccorso?: boolean;
  nomeProntoSoccorso?: string;
  comuneProntoSoccorso?: string;
};

export type TestimoniDTO = {
  nome: string;
  cognome: string;
  indirizzo: string;
  codiceFiscale?: string;
  email: string;
  telefono: string;
  luogoNascita: string;
  dataNascita: string;
};

export type CircostanzeIncidenteDTO = {
  inFermataOSosta: boolean;
  ripartivaDopoSosta: boolean;
  stavaParcheggiando: boolean;
  entravaInUnParcheggio: boolean;
  uscivaDaParcheggio: boolean;
  siImmettevaInUnaPiazza: boolean;
  circolavaSuUnaPiazza: boolean;
  tamponavaStessoSenso: boolean;
  procedevaStessoSenso: boolean;
  cambiavaFila: boolean;
  sorpassava: boolean;
  giravaADestra: boolean;
  giravaASinistra: boolean;
  retrocedeva: boolean;
  invadeSede: boolean;
  provieneDestra: boolean;
  noPrecedenzaOSemaforoRosso: boolean;
  tipoVeicolo: VehicleType;
};

export type VerificaResponsabilitaDTO = {
  success: boolean;
  message: string;
  data: EsitoResponsabilita;
  errors: string[];
  errorCode: string;
  timestamp: string;
  path: string;
};

export enum EsitoResponsabilita {
  REASON = "Ragione",
  WRONG = "Torto",
  CONTEST = "Concorso",
  NOT_CODIFIABLE = "Non codificabile",
}
